import { render, staticRenderFns } from "./PotensiMain.vue?vue&type=template&id=2eeb32be&scoped=true"
import script from "./PotensiMain.vue?vue&type=script&lang=js"
export * from "./PotensiMain.vue?vue&type=script&lang=js"
import style0 from "./PotensiMain.vue?vue&type=style&index=0&id=2eeb32be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eeb32be",
  null
  
)

export default component.exports